export default __webpack_public_path__ + "static/cryptoPortfolio-c46f62276c61f9f8f945bd6d5a1c9f18.svg";